import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoCompleteDenialCodeComponent } from './auto-complete-denial-code.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DenialCodeModule } from '../denial-code/denial-code.module';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DenialCodeModule,
    Trip2ThemeModule
  ],
  declarations: [AutoCompleteDenialCodeComponent],
  exports: [AutoCompleteDenialCodeComponent]
})
export class AutoCompleteDenialCodeModule { }



// WEBPACK FOOTER //
// ./src/app/utils/auto-complete-denial-code/auto-complete-denial-code.module.ts